/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";

export class otheritemsreceiving extends IceEntity {
  other_items_receiving_key: string = "";
  other_items_key: string = "";
  purchase_delivery_key: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  trans_account: string = "";
  date_received: any = NaN;
  item_abstract: string = "";
  sku_num: string = "";
  po_num: string = "";
  quantity: number = 0.0;
  unit_type: string = "";
  inv_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cst_sup_coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cost: number = 0.0;
  tracking_num: string = "";
  rec_notes: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
  return "OTHER_ITEMS_RECEIVING";
  }
}

